/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type EocIncidentsEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const eocIncidentsEntryPoint: EntryPoint<EocIncidentsEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<EocIncidentsEntryPointComponent>(
			/* webpackChunkName: "async-eoc-incidents" */ './EocIncidents.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: () => ({}),
	});
